import { useParams } from "react-router-dom";

const RegisterCompleted = () => {
  let status = useParams().status;
  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%' }}>
      {
        status === "new" &&
        <h1>
          ההרשמה בוצעה בהצלחה
          <br />
          ברגעים אלה נשלחה לכתובת הדואר האלקטרוני שהזנת הודעות אישור
        </h1>
      }
      {
        status === "already" &&
        <h1>
          הנך כבר רשום לאימון,
          <br/>
          בתום ההרשמה נשלחה הודעת אישור הרשמה לכתובת הדואר האלקטרוני שהזנת
          <br/>
          במידה ואינך מוצא את ההודעה ניתן ליצור קשר עם המדריך לשליחה מחדש
        </h1>
      }
      <h1>ניתן לסגור חלון זה כעת<br/>תודה</h1>
    </div>
  )
}

export default RegisterCompleted